import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "@babel/runtime/helpers/esm/toArray";
import Globalize from '@sprinx/globalize';
import invariant from 'invariant';

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (v) {
    return fns.reduce(function (r, fn) {
      return fn(r);
    }, v);
  };
};

export default function addressCountryFormatter(placeFull, countryCode) {
  var splitSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
  var joinSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ', ';
  invariant(countryCode, 'addressCountryFormatter(): country code is required.');

  var formatAddress = function formatAddress(p) {
    return p.join(joinSeparator);
  };

  var tryFindCountryName = function tryFindCountryName() {
    var cc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xxxx';
    return (// ak nie je definovany kod krajiny, zvol urcite neexistujuci
      Globalize.locale().main("localeDisplayNames/territories/".concat(cc.toUpperCase().trim()))
    );
  };

  return !placeFull ? '' : pipe(function (_ref) {
    var _ref2 = _toArray(_ref),
        p1 = _ref2[0],
        p2 = _ref2[1],
        rest = _ref2.slice(2);

    var cc = rest.pop();
    var wc = [p1, p2].concat(_toConsumableArray(rest));
    return [wc.filter(Boolean), cc];
  }, function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        wc = _ref4[0],
        cc = _ref4[1];

    return [wc, tryFindCountryName(cc)];
  }, function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        wc = _ref6[0],
        x = _ref6[1];

    return [wc, x || tryFindCountryName(countryCode)];
  }, function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        wc = _ref8[0],
        x = _ref8[1];

    return [wc, x || 'N/A'];
  }, function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        wc = _ref10[0],
        cn = _ref10[1];

    return formatAddress([].concat(_toConsumableArray(wc), [cn]));
  })(placeFull.split(splitSeparator).map(function (p) {
    return p.trim();
  }));
}